var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"flex-end",attrs:{"row":""}},[_c('v-menu',{attrs:{"bottom":"","left":"","disabled":""}},[_c('v-btn',{staticClass:"grey--text",attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }